import { Controller } from "@hotwired/stimulus"

// Toggles the plans page between monthly and yearly pricing.
// Turbo-safe: connect() re-runs on every navigation (including restore
// from cache), so listeners are re-bound automatically.
export default class extends Controller {
  static targets = ["button", "card", "periodLink"]

  connect() {
    this.period = "monthly"
    this.render()
  }

  select(event) {
    const period = event.currentTarget.dataset.period
    if (!period || period === this.period) return
    this.period = period
    this.render()
  }

  render() {
    this.buttonTargets.forEach((btn) => {
      const active = btn.dataset.period === this.period
      btn.classList.toggle("bg-surface", active)
      btn.classList.toggle("text-foreground", active)
      btn.classList.toggle("shadow-sm", active)
      btn.classList.toggle("text-foreground-muted", !active)
    })

    // Only switch a card's price when the requested period exists in that card;
    // plans without a yearly price keep showing their monthly figure.
    this.cardTargets.forEach((card) => {
      const prices = card.querySelectorAll("[data-price]")
      if (!prices.length) return
      const hasPeriod = card.querySelector(`[data-price="${this.period}"]`)
      prices.forEach((el) => {
        el.hidden = hasPeriod ? el.dataset.price !== this.period : el.dataset.price !== "monthly"
      })
    })

    this.periodLinkTargets.forEach((link) => {
      const url = this.period === "yearly" ? link.dataset.planYearlyUrl : link.dataset.planMonthlyUrl
      if (url) link.href = url
    })
  }
}
